import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {SelectSnapshot} from '@ngxs-labs/select-snapshot';
import {AuthState} from '../../../state/auth/auth.state';
import {SystemUser} from '../../../models/system-user.model';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[roleCheck]'
})
export class RoleCheckDirective {
    @SelectSnapshot(AuthState.currentUser) currentUser: SystemUser;

    constructor(
        private tRef: TemplateRef<any>,
        private vcRef: ViewContainerRef,
    ) {
    }

    @Input() set roleCheck([userRole, expectedValue]) {
        if (
            !userRole
            || (userRole && (this.currentUser.roles?.includes(userRole) === expectedValue))
        ) {
            this.vcRef.createEmbeddedView(this.tRef);
        } else {
            this.vcRef.clear();
        }
    }
}
